import React from 'react'
import { useParams } from 'react-router-dom'
import SearchIcon from "../../../../icons/Search-White.svg"
import { translate } from '../../../../utils/translator'

type Props = {
  value: string
  onChange: (value: string) => void
  className?: string
}

const ProductSearch: React.FC<Props> = ({ value, onChange, className }) => {
  const { language } = useParams();

  return (
    <div id='product-search-container' className={`w-full min-w-0 overflow-hidden shadow-sm rounded-md items-center flex justify-between gap-4 py-3 px-4 bg-white ${className || ''}`}>
      <input
        id='product-search'
        className='text-[16px] h-full w-full min-w-0 flex-1 border-none rounded-md focus:outline-none'
        type="text"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={translate(language, 'choose_treatment', 'default/search_placeholder')}
      />
      <img src={SearchIcon} id='product-search-icon' className='bg-primary-button-gradient rounded-md flex justify-center p-2 text-xl text-white items-center' alt="" />
    </div>
  )
}

export default ProductSearch
